export const env = {
    BASE_URL: '/ranchsatdb',
    BACKEND: 'https://bioinfo.usu.edu/ranchbackend'
}
